import HttpClient from "../http/http_client";

export const getHomeVideoRequest = async () => {
    try {
        const response = await HttpClient.get("home-video/");
        return {
            success: true,
            data: response.data,
        };
    } catch (error) {
        if (error.response) {
            const { status, data } = error.response;
            return {
                success: false,
                status: status,
                errors: data?.errors || data?.message || null,
            };
        }
        return { success: false };
    }
};
